import {  Box, Button, Container, Paper } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import globalContext from '../context/context'
import LoginComponent from "../components/authentication/LoginComponent";
import { useTranslation } from "react-i18next";

function Login() {

    const { t } = useTranslation();
    const { contextData: { user, authKey }, isLoggedIn } = useContext(globalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn()) {
            navigate('/');
        }
    }, [user, authKey])


    return (
        <>
            <Box className="orderElement" sx={{ bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <Paper className="orderElementPaper" sx={{ width: {xs: '95%', md: '60%'}, p: 3, bgcolor: '#fff' }}>
                        <Box sx={{fontWeight: 'bold', textAlign: 'center', fontSize: '1.5rem', pb: 3}}>{t("LoginComponent.login")}</Box>
                        <Box>
                            <LoginComponent />
                            <Button variant="text" component={Link} to="/forgot-password" >Did you forget your password?</Button>
                        </Box>
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default Login;
